// extracted by mini-css-extract-plugin
export default {"profile":"Profile_profile__id1LX","middle":"Profile_middle__pBVhq"};